import invert from 'lodash/invert';

export const BillingProcess = {
  GeneratingInvoices: 0,
  FinalizingInvoices: 1,
  AbortingInvoices: 2,
  NotProcessing: 3
};

export default Object.freeze({
  ...BillingProcess,
  ...invert(BillingProcess)
});
